import React, {useEffect} from 'react';
import Pusher from 'pusher-js';

// import Scss
import './assets/scss/themes.scss';

// imoprt Route
import Route from './Routes/Index';

import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {messaging, onMessage} from './firebase';
import {type AppDispatch} from 'store';
import {useDispatch} from 'react-redux';
import {fetchNotifications} from 'slices/notification/thunk';
import {
  addNotification,
  updateNotificationCount,
} from 'slices/notification/reducer';
import Message from 'Common/Message';
import {variables} from 'utils/constant';
import Cookies from 'js-cookie';

const App = (): React.JSX.Element => {
  const dispatch = useDispatch<AppDispatch>();
  // const pusherRef = useRef<Pusher | null>(null);
  // useEffect(() => {
  //   // Function to request notification permission and retrieve token
  //   const requestPermission = async (): Promise<void> => {
  //     try {
  //       // Request permission for notifications
  //       const permission = await Notification.requestPermission();

  //       if (permission === 'granted') {
  //         // Register the service worker
  //         navigator.serviceWorker
  //           .register('/firebase-messaging-sw.js')
  //           .then(registration => {
  //             console.log('Service Worker registered:', registration.scope);

  //             // Ensure the service worker is active before requesting the token
  //             if (navigator.serviceWorker.controller != null) {
  //               console.log('Service Worker is active, requesting token...');
  //               // Get the FCM token
  //               getToken(messaging, {
  //                 vapidKey: process.env.REACT_APP_VAPID_KEY, // Make sure to set the correct VAPID key
  //                 serviceWorkerRegistration: registration, // Pass the service worker registration
  //               })
  //                 .then(currentToken => {
  //                   console.log('FCM Token:', currentToken);
  //                 })
  //                 .catch(err => {
  //                   console.error('Error getting token:', err);
  //                 });
  //             } else {
  //               console.log('Service Worker not active, retrying...');
  //               location.reload();
  //               // You can retry or wait for the service worker to be active
  //             }
  //           })
  //           .catch(error => {
  //             console.error('Service Worker registration failed:', error);
  //           });
  //       } else {
  //         // alert('Notification permission denied');
  //         // if (confirm('Notification permission denied!')) {
  //         //   window.location.href = 'chrome://settings/content/notifications';
  //         // } else {
  //         //   alert('You pressed Cancel!');
  //         // }
  //       }
  //     } catch (error) {
  //       console.error('Error requesting permission:', error);
  //     }
  //   };

  //   // Request permission and initialize the service worker and Firebase token
  //   void requestPermission();
  // }, []); // Empty dependency array ensures this runs only once when the component mounts

  useEffect(() => {
    const unsubscribe = onMessage(messaging, payload => {
      console.log('Message received in foreground:', payload);

      // Dispatch notification to Redux store
      // dispatch(
      //   addNotification({
      //     id: Date.now().toString(),
      //     title: payload?.notification?.title,
      //     message: payload?.notification?.body,
      //   }),
      // );

      // toast(
      //   <Message notification={payload.notification} data={payload.data} />,
      // );
    });

    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    // if (!pusherRef.current) {
    const pusher = new Pusher(`${process.env.REACT_APP_PUSHER_APP_KEY}`, {
      cluster: `${process.env.REACT_APP_PUSHER_APP_CLUSTER}`,
      // encrypted: true,
    });
    const channel = pusher.subscribe('puravida');

    channel.bind('create', (data: any) => {
      // console.log('Pusher notification received:', data);

      dispatch(
        addNotification({
          id: Date.now().toString(),
          title: data?.notification?.title,
          message: data?.notification?.description,
        }),
      );

      toast(
        <Message
          notification={{
            title: data?.notification?.title,
            body: data?.notification?.description,
            type: data?.notification?.type,
          }}
          data={data}
        />,
      );

      dispatch(updateNotificationCount(data?.notificationCount));
    });

    //   pusherRef.current = pusher;
    // }

    return () => {
      unsubscribe();
    }; // Cleanup function
  }, []); // Runs only once when App mounts

  useEffect(() => {
    // Fetch notifications initially
    const authDetails = Cookies.get(variables?.ecommerce_admin);
    if (authDetails != null) {
      void dispatch(fetchNotifications());
    }
  }, [dispatch]);

  return (
    <React.Fragment>
      <Route />
      <ToastContainer />
    </React.Fragment>
  );
};

export default App;
